import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useLoginSelector from '../Login/LoginSelector';

const EMPTY_ARRAY = [];
const EMPTY_OBJ = {};

export default function useGlobalSelector() {
  const { LoginData } = useLoginSelector();

  const StateData = useSelector((state) => state.Global.state_data) || EMPTY_ARRAY; // State list
  const CityData = useSelector((state) => state.Global.city_data) || EMPTY_ARRAY; // City list
  const LoanTypeData = useSelector((state) => state.Global?.loan_type_data) || EMPTY_OBJ; // Loan Type list
  const BankDropdownData = useSelector((state) => state.Global.band_drop_data) || EMPTY_OBJ; // Bank Dropdown
  const BankDropdownData2 = useSelector((state) => state.Global.bank_dropdown_data) || EMPTY_OBJ; // Bank Dropdown

  const BankBranchDetails =
    useSelector((state) => state.Global.branch_data?.branches) || EMPTY_ARRAY; // Bank Branch Details
  const SourceData = useSelector((state) => state.Global.source_data) || EMPTY_OBJ; // Source Data List
  const AccessLevelConfig = useSelector((state) => state.Global.config_data) || EMPTY_OBJ; // Access Level Config data
  const InternalSaleManager = useSelector((state) => state.Global.manager_data) || EMPTY_OBJ; // Internal Sale Manager Data
  const StatusData = useSelector((state) => state.Global.status_data) || EMPTY_ARRAY; // Status Data
  const AllEmpMasterList = useSelector((state) => state.Global.emp_master_list) || EMPTY_OBJ; // All Employee Master list
  const MasterTypeList = useSelector((state) => state.Global.master_type) || EMPTY_OBJ; // Master Type List
  const PartnerStatus =
    useSelector((state) => state.Global.partner_status?.partnerTypes) || EMPTY_ARRAY; // Partner status
  const DocsTypes = useSelector((state) => state.Global.docs_type?.documentTypes) || EMPTY_ARRAY; // Documents types
  const PartnerCompanyTypes =
    useSelector((state) => state.Global.partner_company?.partnerCompanyTypes) || EMPTY_ARRAY; // Partner Company types
  const PartnerStatusTypes =
    useSelector((state) => state.Global.partner_status_company?.partnerStatusTypes) || EMPTY_ARRAY; // Partner Status Types
  const MasterLoanType =
    useSelector((state) => state.Global.master_loan_types?.loanTypes) || EMPTY_ARRAY; // master loan types
  const ParentLoanMasterList =
    useSelector((state) => state.Global.parent_loan_master?.loanMasters) || EMPTY_ARRAY; // Parent Loan Master List
  const ParentEmpTypesList =
    useSelector((state) => state.Global.parent_emp_types?.empTypes) || EMPTY_ARRAY; // parent emp types List
  const EmpTypesList = useSelector((state) => state.Global.emp_types?.subEmpTypes) || EMPTY_ARRAY; // Emp Types List
  const LoanSubTypeList =
    useSelector((state) => state.Global.company_loan_master?.loanTypes) || EMPTY_ARRAY; // Loan Sub Type List

  const AccessLevelList = useSelector((state) => state.Global.access_level_data) || EMPTY_OBJ; // Access Level Data
  const DepartmentList = useSelector((state) => state.Global.department_list) || EMPTY_ARRAY; // Department List
  const SignUpDocTypeData = useSelector((state) => state.Global.signUpDocsType) || EMPTY_ARRAY; // Department List

  // const UsersList = useSelector((state) => state.Global.user_list) || EMPTY_OBJ; // Users List

  // console.log('ParentLoanMasterList', ParentLoanMasterList);

  const stateDrop = useMemo(
    () =>
      (StateData || EMPTY_ARRAY)?.map((item) => ({
        label: item?.stateName,
        value: item?.stateId
      })),
    [StateData]
  );

  const CityDrop = useMemo(
    () =>
      (CityData || EMPTY_ARRAY)?.map((item) => ({
        label: item?.cityName,
        value: item?.cityId
      })),
    [CityData]
  );

  const LoanTypeDrop = useMemo(
    () =>
      (LoanTypeData?.loanTypes || EMPTY_ARRAY)?.map((item) => ({
        label: item?.loanName,
        value: item?.loanId
      })),
    [LoanTypeData]
  );
  const BankDrop = useMemo(
    () =>
      (BankDropdownData?.banks || EMPTY_ARRAY)?.map((item) => ({
        label: item?.bankName,
        value: item?.bankId
      })),
    [BankDropdownData]
  );
  const BankList = useMemo(
    () =>
      (BankDropdownData2?.banks || EMPTY_ARRAY)?.map((item) => ({
        label: item?.bankName,
        value: item?.bankId
      })),
    [BankDropdownData2]
  );
  const SourceDrop = useMemo(
    () =>
      (SourceData?.prospectSourceTypes || EMPTY_ARRAY)?.map((item) => ({
        label: item?.typeName,
        value: item?.typeId
      })),
    [SourceData]
  );
  const InternalSaleManagerDrop = useMemo(
    () =>
      (InternalSaleManager?.salesPersons || EMPTY_ARRAY)?.map((item) => ({
        label: item?.fullName,
        value: item?.userId
      })),
    [InternalSaleManager]
  );

  const InternalSaleManagerFilterDrop = useMemo(
    () => InternalSaleManagerDrop?.filter((item) => LoginData?.userId !== item?.value),
    [InternalSaleManagerDrop, LoginData?.userId]
  );

  const StatusDrop =
    useMemo(
      () =>
        (StatusData || EMPTY_ARRAY)?.map((item) => ({
          label: item?.stageStatusName,
          value: item?.stageStatusId
        })),
      [StatusData]
    ) || EMPTY_ARRAY;

  const AllEmpMasterDrop =
    useMemo(
      () =>
        (AllEmpMasterList?.empSubTypes || EMPTY_ARRAY)?.map((item) => ({
          label: `${item?.employmentSubcategoryName} - ${item?.employmentSubcategoryCode}`,
          value: item?.employmentSubcategoryId
        })),
      [AllEmpMasterList]
    ) || EMPTY_ARRAY;

  const MasterTypeListDrop =
    useMemo(
      () =>
        (MasterTypeList?.masterTypes || EMPTY_ARRAY)?.map((item) => ({
          label: item?.typeName,
          value: item?.typeId
        })),
      [MasterTypeList]
    ) || EMPTY_ARRAY;

  const BankBranchDrop =
    useMemo(
      () =>
        (BankBranchDetails || EMPTY_ARRAY)?.map((item) => ({
          label: item?.branchName,
          value: item?.branchId
        })),
      [BankBranchDetails]
    ) || EMPTY_ARRAY;

  const PartnerStatusDrop =
    useMemo(
      () =>
        (PartnerStatus || EMPTY_ARRAY)?.map((item) => ({
          label: item?.typeName,
          value: item?.typeId
        })),
      [PartnerStatus]
    ) || EMPTY_ARRAY;

  const DocsTypesDrop =
    useMemo(
      () =>
        (DocsTypes || EMPTY_ARRAY)?.map((item) => ({
          label: item?.typeName,
          value: item?.typeId,
          typeCode: item?.typeCode
        })),
      [DocsTypes]
    ) || EMPTY_ARRAY;

  const PartnerCompanyTypesDrop =
    useMemo(
      () =>
        (PartnerCompanyTypes || EMPTY_ARRAY)?.map((item) => ({
          label: item?.typeName,
          value: item?.typeId
        })),
      [PartnerCompanyTypes]
    ) || EMPTY_ARRAY;

  const MasterLoanTypeDrop =
    useMemo(
      () =>
        (MasterLoanType || EMPTY_ARRAY)?.map((item) => ({
          label: item?.loanName,
          value: item?.loanId
        })),
      [MasterLoanType]
    ) || EMPTY_ARRAY;

  const ParentLoanMasterListDrop =
    useMemo(
      () =>
        (ParentLoanMasterList || EMPTY_ARRAY)?.map((item) => ({
          label: item?.parentLoanName,
          value: item?.parentLoanId
        })),
      [ParentLoanMasterList]
    ) || EMPTY_ARRAY;

  const ParentEmpTypesListDrop =
    useMemo(
      () =>
        (ParentEmpTypesList || EMPTY_ARRAY)?.map((item) => ({
          label: item?.employmentCategoryName,
          value: item?.employmentCategoryId
        })),
      [ParentEmpTypesList]
    ) || EMPTY_ARRAY;

  const EmpTypesListDrop =
    useMemo(
      () =>
        (EmpTypesList || EMPTY_ARRAY)?.map((item) => ({
          label: item?.employmentSubcategoryName,
          value: item?.employmentSubcategoryId
        })),
      [EmpTypesList]
    ) || EMPTY_ARRAY;

  const LoanSubTypeListDrop =
    useMemo(
      () =>
        (LoanSubTypeList || EMPTY_ARRAY)?.map((item) => ({
          label: item?.loanName,
          value: item?.loanId
        })),
      [LoanSubTypeList]
    ) || EMPTY_ARRAY;

  const DepartmentListDrop =
    useMemo(
      () =>
        (DepartmentList || EMPTY_ARRAY)?.map((item) => ({
          label: item?.departmentName,
          value: item?.departmentId
        })),
      [DepartmentList]
    ) || EMPTY_ARRAY;

  return {
    stateDrop,
    CityDrop,
    LoanTypeDrop,
    BankDrop,
    BankList,
    BankDropdownData,
    SourceDrop,
    AccessLevelConfig,
    InternalSaleManagerDrop,
    InternalSaleManagerFilterDrop,
    StatusDrop,
    AllEmpMasterDrop,
    MasterTypeListDrop,
    BankBranchDrop,
    PartnerStatusDrop,
    DocsTypesDrop,
    PartnerCompanyTypesDrop,
    PartnerStatusTypes,
    MasterLoanTypeDrop,
    ParentLoanMasterListDrop,
    ParentEmpTypesListDrop,
    EmpTypesListDrop,
    LoanSubTypeListDrop,
    AccessLevelList,
    DepartmentListDrop,
    SignUpDocTypeData
  };
}
